/* eslint-disable no-unused-expressions */
import React from 'react';

import './index.scss';

function publishConfirmation({modalId, publishAction, cancelAction}) {
  const renderPublishDesign = () => (
    <div className='cb-btn-row footerbottomRow'>
      {/* <!-- close button --> */}
      <button type='button' className='cb-btn cb-btn-naked' onClick={cancelAction} data-cb-modal-close aria-label='Continue editing'>Continue Editing</button>
      <button type='button' className='cb-btn cb-btn-primary' onClick={publishAction} data-cb-modal-close>Accept Now</button>
    </div>
  );
  return(
    <div className='cb-modal' id={`${modalId}`} aria-hidden='true'
      data-cb-apricot='modal'>
      <div className='cb-modal-overlay' tabIndex='-1'>
        <div className='cb-modal-container' role='dialog' aria-modal='true' aria-labelledby={`${modalId}_Title`} aria-describedby={`dialogueDsc_${modalId}`}>
          <div className='cb-modal-header'>
            <div id={`${modalId}_Title`} className='display-flex justify-content-start align-items-center headerStyle' style={{width: '100%'}}>
              <span aria-hidden='true' style={{marginRight: '5px'}} className='cb-icon cb-icon-circular cb-megaphone'></span>
              <span role='heading' aria-level='2' style={{display: 'flex', flexWrap:'wrap', justifyContent: 'center'}}>Are you sure this category is ready to be accepted?</span>
            </div>
            {/* <!-- close button --> */}
            <button type='button' onClick={cancelAction} className='cb-btn cb-btn-square cb-btn-greyscale cb-btn-close' aria-describedby={`${modalId}_Title`} data-cb-modal-close>
              <span className='cb-icon cb-x-mark' aria-hidden='true' />
              <span className='sr-only'>Close</span>
            </button>
          </div>
          <div className='cb-modal-content' id={`dialogueDsc_${modalId}`}>
            <p>
            Once accepted, this category will be live. Please confirm you are ready to accept this category.
            </p>
          </div>
          <div className='cb-modal-footer'>
            {renderPublishDesign()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default publishConfirmation;